let audioContext: AudioContext | null = null

/** Call from the scan button press so mobile browsers allow the success sound. */
export async function prepareScannerAudio() {
	if (typeof window === 'undefined') return
	const AudioContextConstructor = window.AudioContext
	if (!AudioContextConstructor) return
	audioContext ??= new AudioContextConstructor()
	if (audioContext.state === 'suspended') await audioContext.resume()
}

export function playScanSuccessSound() {
	if (!audioContext || audioContext.state !== 'running') return
	const oscillator = audioContext.createOscillator()
	const gain = audioContext.createGain()
	const now = audioContext.currentTime
	oscillator.type = 'sine'
	oscillator.frequency.setValueAtTime(880, now)
	gain.gain.setValueAtTime(0.0001, now)
	gain.gain.exponentialRampToValueAtTime(0.18, now + 0.01)
	gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.12)
	oscillator.connect(gain)
	gain.connect(audioContext.destination)
	oscillator.start(now)
	oscillator.stop(now + 0.13)
}
